import { useToast } from "@mallardbay/lib-react-components"

import { useStopImpersonationMutation } from "~graphql/auth.generated"

export default function useStopImpersonation({
    onSuccess,
}: {
    onSuccess?: () => void
} = {}) {
    const { showError } = useToast()

    const [stopImpersonation, { loading: isLoading }] =
        useStopImpersonationMutation({
            onCompleted: onSuccess,
            onError: showError,
        })

    return { stopImpersonation, isLoading }
}
